import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton } from '@mui/material';
import { FC, useState } from 'react';
import { ManagedCommItem } from '../../../../../../../hooks/use-communications/types/managed-communication';
import { CircularProgress } from '../../../../../../shared/audio-player/styles';
import { CommStatusIcon } from '../comm-status-icon/comm-status-icon';
import { TitleStatusText, TitleStatusWrapper, TitleText, TitleTextWrapper } from './managed-comm-card-title.styles';

export interface ManagedCommCardTitleProps {
  communication: ManagedCommItem;
  disableClick?: boolean;
  onClickOnly?: () => Promise<void>;
  onExpand?: () => Promise<void>;
  onCollapse?: () => Promise<void>;
}

export const ManagedCommCardTitle: FC<ManagedCommCardTitleProps> = (props) => {
  const { communication, disableClick, onClickOnly, onExpand, onCollapse } = props;
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleCollapseClick = async () => {
    if (onClickOnly) {
      onClickOnly();
      return;
    }

    if (loading) return;

    setLoading(true);
    !expanded && onExpand && (await onExpand());
    expanded && onCollapse && (await onCollapse());
    setExpanded(!expanded);
    setLoading(false);
  };

  return (
    <Box>
      <TitleTextWrapper>
        <TitleText>{communication.subject}</TitleText>
        {loading && <CircularProgress color={'secondary'} size={17} sx={{ color: '#089af7', padding: '4px' }} />}
        {!loading && !disableClick && (
          <IconButton sx={{ width: '25px', height: '25px' }} onClick={handleCollapseClick}>
            {onClickOnly && <KeyboardArrowRightIcon sx={{ fontSize: '1.2rem' }} />}
            {!onClickOnly &&
              (expanded ? (
                <KeyboardArrowUpIcon sx={{ fontSize: '1.2rem' }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ fontSize: '1.2rem' }} />
              ))}
          </IconButton>
        )}
      </TitleTextWrapper>
      <TitleStatusWrapper>
        <CommStatusIcon commStatus={communication.status} />
        <TitleStatusText>{communication.statusString}</TitleStatusText>
      </TitleStatusWrapper>
    </Box>
  );
};
